import { ILmpBlock } from "@sky-it-livedata/livedata-sports-design-system";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { isValidLmpHeroStickySubscription } from "./typeguards";
import {  LmpHero, UpdateLmpHeroInputSchema } from "appsync";
import { LmpHeroStickySubscription } from "../types";


export interface IMatchHero {
  readonly match: LmpHero;
  readonly hasVideo?: boolean;
  readonly isSlim?: boolean;
  readonly hasFollowMatch?: boolean | null;
}

type ITransformedMatch = ILmpBlock['match'] & {
  customCompetitionName?: string;
};

const transformerSubscription = (obj: LmpHeroStickySubscription): ILmpBlock => {
  
  if (isValidLmpHeroStickySubscription(obj)) {
    UpdateLmpHeroInputSchema().parse(obj.data?.onUpdateLmpHeroStickyByMatchId);
    const { competition, createdAt, updatedAt, status, ...match } = obj.data.onUpdateLmpHeroStickyByMatchId;  
    const {logoUrl:logoUrlAway, ...away} = match.away!;
    const {logoUrl:logoUrlHome, ...home} = match.home!;

    type ILmpBlockPartial = Omit<ILmpBlock, 'matchId'>;

    const payload: ILmpBlockPartial = {
      match: {
        status: status as ITransformedMatch['status'],
        away: {
          ...away,
        } as ITransformedMatch['away'],
        home: {
          ...home,
        } as ITransformedMatch['home'],
      },
    };

    return payload;
  } else {
    throw new WidgetError<ErrorName>({
      name: "NO_VALID_DATA",
      message: "Invalid transformer input, Error in LmpHeroStickySubscription object",
      data: obj,
    });
  }
};

export default transformerSubscription;
